import { useState } from "react";
import { Text, Flex, Box } from "@mantine/core";
import { actions } from "../../../../store/useStore";

export const ExpandableBio = ({ ambassador }: { ambassador: any }) => {
  const [expanded, setExpanded] = useState(false);
  const words = ambassador?.bio?.split(" ") || [];
  const shortBio = words.slice(0, 20).join(" ");
  const isTruncated = words.length > 20;

  return (
    <Flex direction="column" gap="xs">
      <Box
        style={{
          maxHeight: expanded ? 120 : 80,
          overflowY: "auto",
          transition: "max-height 0.2s ease",
          scrollbarWidth: "thin",
          msOverflowStyle: "none",
        }}
      >
        <Text size="sm" mt="md">
          {expanded || !isTruncated ? (
            ambassador?.bio
          ) : (
            <>
              {shortBio}
              <Text
                component="span"
                color="blue"
                style={{ cursor: "pointer" }}
                onClick={() => actions.ambassadors.openSingleCardView(ambassador)}
              >
                {" "}
                [...]
              </Text>
            </>
          )}
        </Text>
      </Box>
    </Flex>
  );
};
